import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Tag } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { Button } from "@/components/ui/button";
import RegistrationDialog from "@/components/RegistrationDialog";
import { useAuth } from "@/context/AuthContext";
import { PRICING } from "@/context/Api";



const PERKS = [
  "1 Exam Attempt",
  "Official HCASP Study Guide",
];

const Pricing = () => {
  const navigate = useNavigate();
  const { user } = useAuth(); // ✅ to check if the person is logged in
  const [pricing, setPricing] = useState(null);
  const [dialog, setDialog] = useState(null); // 'india' | 'international' | null

  useEffect(() => {
    PRICING()
      .then((r) => setPricing(r.data))
      .catch(() => { });
  }, []);

  const cards = [
    {
      region: "india",
      title: "India",
      badge: "Standard India Pricing ",
      data: pricing?.india,
      featured: true,
    },
    {
      region: "international",
      title: "International",
      badge: "Global",
      data: pricing?.international,
      featured: false,
    },
  ];

  const active = cards.find((c) => c.region === dialog);

  // ✅ Logged in → open the registration dialog for that region.
  // ✅ Not logged in → send them straight to the signup page.
  const handleRegisterClick = (region) => {
    if (user) {
      setDialog(region);
    } else {
      navigate("/sign-up");
    }
  };

  return (
    <section
      id="pricing"
      data-testid="pricing"
      className="relative py-28 md:py-36"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal>
            <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#16fcfb]">
              [ 009 ] Pricing & Registration
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display font-700 text-4xl md:text-5xl leading-[1.05] tracking-tight text-white">
              Secure your seat.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 font-body text-base text-white/65 leading-relaxed">
              Invest in your AI security career with flexible pricing and partner membership options.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {cards.map((c, i) => (
            <Reveal key={c.region} delay={0.08 * i} className="h-full">
              <div
                data-testid={`pricing-card-${c.region}`}
                className={`relative h-full flex flex-col rounded-2xl border p-8 md:p-10 transition-colors duration-300 ${c.featured
                  ? "border-[#16fcfb] bg-[#16fcfb]/[0.06] glow-cyan"
                  : "border-[#3d414f] bg-[#404452]/20 hover:border-[#97b8ff]"
                  }`}
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-display font-700 text-2xl text-white">
                    {c.title}
                  </h3>
                  <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] px-3 py-1 rounded-full border border-[#3d414f] text-[#97b8ff]">
                    {c.badge}
                  </span>
                </div>

                <div className="mt-8 flex items-end gap-2">
                  <span
                    data-testid={`price-${c.region}`}
                    className="font-display fopacity-60 font-light text-base md:text-lg mr-2 text-white text-glow-cyan"
                  >
                    {/* {c.region === "india" && (
                      <span className="line-through opacity-60 font-light text-base md:text-lg mr-2">
                        ₹19,999 -
                      </span>
                    )} */}

                    {c.data ? c.data.display : "—"}
                    {c.region === "india" ? " Incl. GST " : ""}
                  </span>
                </div>
                {/* <p className="mt-2 font-body text-sm text-white/55">
                  Includes: 1 Exam Attempt, Official HCASP Study Guide, and Practical Lab Manual.
                </p> */}

                <ul className="mt-8 space-y-3 flex-1">
                  {PERKS.map((p) => (
                    <li key={p} className="flex items-center gap-3">
                      <span className="grid h-5 w-5 place-items-center rounded-full bg-[#16fcfb]/15 text-[#16fcfb]">
                        <Check size={13} />
                      </span>
                      <span className="font-body text-sm text-white/80">{p}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  data-testid={`register-btn-${c.region}`}
                  onClick={() => handleRegisterClick(c.region)}
                  className={`mt-8 w-full rounded-full h-12 font-mono2 text-xs uppercase tracking-widest ${c.featured
                    ? "bg-[#16fcfb] text-[#07070c] hover:bg-[#97b8ff]"
                    : "bg-transparent border border-[#4d4479] text-white hover:bg-[#404452]"
                    }`}
                >
                  Register Now
                </Button>
                {/* <div className="mt-3 text-center font-mono2 text-sm md:text-base tracking-widest text-[#16fcfb]">
                  Coupon:{" "}
                  <span className="font-bold ">
                    {c.region === "india" ? "HCASP100" : "HCASPINT"}
                  </span>
                </div> */}
              </div>

            </Reveal>
          ))}
        </div>


      </div>

      {user && (
        <RegistrationDialog
          open={Boolean(dialog)}
          onOpenChange={(v) => !v && setDialog(null)}
          region={dialog || "india"}
          priceDisplay={active?.data?.display || ""}

        />
      )}
    </section>
  );
};

export default Pricing;